import React, { useMemo } from 'react';
import ConceptLink from './ConceptLink';
import { useAnswerConcepts, useAnswerArticles } from './AnswerConcepts';
import { collectConceptLinks, conceptSegments } from './conceptLinks';

export default function LinkedHeadline({ headline, body }: { headline: string; body: string }) {
    const answerConcepts = useAnswerConcepts(body);
    const links = useMemo(() => answerConcepts ?? collectConceptLinks(body), [answerConcepts, body]);
    const articles = useAnswerArticles(body);
    const parts = (articles ? articles(headline) : [{ text: headline }]).flatMap(part => part.url
        ? [{ ...part, concept: false }]
        : conceptSegments(part.text, links).map(concept => ({ ...concept, concept: true })));
    return <>{parts.map((part, index) => part.url
        ? <ConceptLink key={index} href={part.url} concept={part.concept}>{part.text}</ConceptLink>
        : <React.Fragment key={index}>{part.text}</React.Fragment>)}</>;
}
